import { useParams } from "react-router-dom";
import useErrorToast from "~/contexts/error-toast";
import { useFetcher } from "~/hooks/useFetcher";
import CeConfigResponse from "~/types/interfaces/ce-config";

const useActiveConfig = () => {
  const { showError } = useErrorToast();
  const { datasetId } = useParams();
  return useFetcher<CeConfigResponse>(
    `/api/cohort-explorer/configurator/configs/active?dataset_id=${datasetId}`,
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      onError: () => {
        showError("Unable to load active configurations");
      },
    }
  );
};

export default useActiveConfig;
